// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let Tooltip = require("../../common/Components/Tooltip.bs.js");
let FilterChip = require("../../common/Components/FilterChip.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SearchPagesUtils = require("../../common/SearchPagesUtils.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyFilterOptions = require("../../common/Form/PropertyFilterOptions.bs.js");
let PropertiesPageRelayQueryParams = require("./PropertiesPageRelayQueryParams.bs.js");

function PropertiesPageRelayActiveFiltersList(props) {
  let refetch = props.refetch;
  let defaultAreas = props.defaultAreas;
  let params = props.params;
  let rentalMode = params.rentalMode;
  let priceOptions = rentalMode ? PropertyFilterOptions.PriceFilters.rentalOptions : PropertyFilterOptions.PriceFilters.forSaleOptions;
  let activeParams = props.selectedAreas.filter(a => Stdlib_Option.getOr(params.areaIds, []).includes(a.id)).map(area => [
    area.label,
    q => {
      let newrecord = {...q};
      let v = Stdlib_Option.getOr(q.areaIds, []).filter(id => id !== area.id);
      newrecord.areaIds = v.length !== 0 ? v : undefined;
      return newrecord;
    }
  ]);
  let activeParams$1 = activeParams.concat(Stdlib_Array.keepSome([
    Stdlib_Option.map(params.minPrice, minPrice => [
      `From $` + Stdlib_Option.getOr(Stdlib_Array.findMap(priceOptions, v => {
        if (v.value === minPrice) {
          return v.label;
        }
      }), minPrice.toString()),
      p => {
        let newrecord = {...p};
        newrecord.minPrice = undefined;
        return newrecord;
      }
    ]),
    Stdlib_Option.map(params.maxPrice, maxPrice => [
      `Up to $` + Stdlib_Option.getOr(Stdlib_Array.findMap(priceOptions, v => {
        if (v.value === maxPrice) {
          return v.label;
        }
      }), maxPrice.toString()),
      p => {
        let newrecord = {...p};
        newrecord.maxPrice = undefined;
        return newrecord;
      }
    ]),
    Stdlib_Option.map(params.minBeds, minBeds => [
      `Min ` + minBeds.toString() + ` bedrooms`,
      p => {
        let newrecord = {...p};
        newrecord.minBeds = undefined;
        return newrecord;
      }
    ]),
    Stdlib_Option.map(params.maxBeds, maxBeds => [
      `Max ` + maxBeds.toString() + ` bedrooms`,
      p => {
        let newrecord = {...p};
        newrecord.maxBeds = undefined;
        return newrecord;
      }
    ])
  ]));
  if (rentalMode) {
    Stdlib_Option.getOr(params.rentalPropertyTypes, []).forEach(rentalPropertyType => {
      let tmp;
      tmp = rentalPropertyType === "CONDO" ? "Condo" : "Single-family";
      activeParams$1.push([
        tmp,
        p => {
          let newrecord = {...p};
          newrecord.rentalPropertyTypes = SearchPagesUtils.toggleIncluded(p.rentalPropertyTypes, rentalPropertyType);
          return newrecord;
        }
      ]);
    });
    if (params.soldOrRented) {
      activeParams$1.push([
        "Rented",
        p => {
          let newrecord = {...p};
          newrecord.soldOrRented = false;
          return newrecord;
        }
      ]);
    }
  } else {
    Stdlib_Option.getOr(params.forSalePropertyTypes, []).forEach(forSalePropertyType => {
      let tmp;
      switch (forSalePropertyType) {
        case "CONDO" :
          tmp = "Condo";
          break;
        case "LOT" :
          tmp = "Lot";
          break;
        case "MULTI_UNIT" :
          tmp = "Multi-unit";
          break;
        case "SINGLE_FAMILY" :
          tmp = "Single-family";
          break;
      }
      activeParams$1.push([
        tmp,
        p => {
          let newrecord = {...p};
          newrecord.forSalePropertyTypes = SearchPagesUtils.toggleIncluded(p.forSalePropertyTypes, forSalePropertyType);
          return newrecord;
        }
      ]);
    });
    if (params.soldOrRented) {
      activeParams$1.push([
        "Sold",
        p => {
          let newrecord = {...p};
          newrecord.soldOrRented = false;
          return newrecord;
        }
      ]);
    }
    if (params.underContract) {
      activeParams$1.push([
        "Under Contract",
        p => {
          let newrecord = {...p};
          newrecord.underContract = false;
          return newrecord;
        }
      ]);
    }
  }
  if (params.withdrawnOrExpired) {
    activeParams$1.push([
      "Withdrawn / Expired",
      p => {
        let newrecord = {...p};
        newrecord.withdrawnOrExpired = false;
        return newrecord;
      }
    ]);
  }
  if (params.active) {
    activeParams$1.push([
      "Active",
      p => {
        let newrecord = {...p};
        newrecord.active = false;
        return newrecord;
      }
    ]);
  }
  let keywords = params.keywords;
  if (keywords !== undefined && keywords.length !== 0) {
    activeParams$1.push([
      "Keywords: " + Utils.$$Array.joinWith(", ", keywords),
      p => {
        let newrecord = {...p};
        newrecord.keywords = [];
        return newrecord;
      }
    ]);
  }
  let match = params.areaIds;
  let tmp;
  if (match !== undefined || defaultAreas === undefined || defaultAreas.length === 0) {
    tmp = null;
  } else {
    let __x = defaultAreas.map(x => x.label);
    tmp = JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(FilterChip.make, {
        children: JsxRuntime.jsx(Tooltip.make, {
          label: Utils.$$Array.pseudoJoin(", ", " and ", __x).join(""),
          children: JsxRuntime.jsx("span", {
            children: "Your chapter default areas"
          })
        })
      }, "chapter_default")
    });
  }
  let tmp$1;
  let exit = 0;
  if (activeParams$1.length !== 0) {
    exit = 1;
  } else {
    let exit$1 = 0;
    if (defaultAreas !== undefined && defaultAreas.length !== 0) {
      exit = 1;
    } else {
      exit$1 = 2;
    }
    if (exit$1 === 2) {
      tmp$1 = JsxRuntime.jsx("div", {
        children: "No filters"
      });
    }
  }
  if (exit === 1) {
    tmp$1 = activeParams$1.map(param => {
      let updater = param[1];
      let text = param[0];
      return JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(FilterChip.make, {
          children: text,
          closeHandler: () => refetch(undefined, undefined, undefined, updater)
        })
      }, text);
    });
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        tmp,
        tmp$1,
        activeParams$1.length > 1 || !params.active ? JsxRuntime.jsx("button", {
            children: "Reset filters",
            className: "self-center underline pl-2",
            type: "button",
            onClick: param => refetch(undefined, undefined, undefined, param => PropertiesPageRelayQueryParams.getDefaultState())
          }) : null
      ],
      className: "flex grow flex-row gap-2 flex-wrap"
    }),
    className: "flex flex-row"
  });
}

let QueryParams;

let make = PropertiesPageRelayActiveFiltersList;

exports.QueryParams = QueryParams;
exports.make = make;
/* Utils Not a pure module */
